import React, { Component } from 'react';
import ChartistGraph from 'react-chartist';

class lineareachart extends Component {
    render() {
        var lineChartData = {
            labels: [0, 0, 0, 0],
            series: [
                [0, 0, 0, 0]
            ]
        };
        var lineChartOptions = {
            low: 0,
            showArea: true,
        }
        return (
            <React.Fragment>
                <ChartistGraph data={lineChartData} style={{ height: "300px" }} options={lineChartOptions} type={'Line'} />
            </React.Fragment>
        );
    }
}

export default lineareachart;